import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Layout from '../components/layout/Layout';
import { projects, clients } from '../data/mock';
import FAQSection from '../components/home/FAQSection';
import StarburstDecor from '../components/ui/StarburstDecor';

const ProjectDetailPage = () => {
  const { id } = useParams();
  const project = projects.find((p) => p.id === parseInt(id));

  if (!project) {
    return (
      <Layout>
        <div className="container-main py-20 text-center">
          <h1 className="text-2xl font-bold text-navy">Project not found</h1>
          <Link to="/projects" className="text-lime hover:underline mt-4 inline-block">
            Back to Projects
          </Link>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      {/* Hero */}
      <section className="bg-white py-16 relative">
        <div className="container-main">
          <Link
            to="/projects"
            className="inline-flex items-center gap-2 text-navy hover:text-lime transition-colors mb-6"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Projects
          </Link>
          <div className="max-w-2xl">
            <h1 className="text-4xl md:text-5xl font-bold text-navy">Project Details</h1>
            <p className="mt-4 text-gray-600">
              Our focus is on creating visually appealing brands, websites, and products for technology startups and companies.
            </p>
          </div>
          <div className="absolute top-8 right-8 hidden lg:block">
            <StarburstDecor size={100} />
          </div>
        </div>
      </section>

      {/* Main Project Image */}
      <section className="bg-white py-8">
        <div className="container-main">
          <div className="rounded-2xl overflow-hidden aspect-video">
            <img
              src={project.image}
              alt={project.title}
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* Project Details */}
      <section className="bg-white py-12">
        <div className="container-main">
          <div className="max-w-3xl">
            <h2 className="text-3xl font-bold text-navy mb-4">{project.title}</h2>
            <div className="flex flex-wrap gap-2 mb-6">
              {project.tags.map((tag) => (
                <span
                  key={tag}
                  className="text-xs font-medium px-3 py-1 bg-lime text-navy rounded-full"
                >
                  {tag}
                </span>
              ))}
            </div>
            <p className="text-gray-600 leading-relaxed mb-8">
              {project.description}
            </p>

            <h3 className="text-2xl font-bold text-navy mb-4">
              Capabilities in web and mobile app design services
            </h3>
            <p className="text-gray-600 leading-relaxed mb-6">
              From competitive analysis to interactive prototypes, our agency implements engaging and simple-to-use user interfaces. Our user-friendly product design helps companies achieve quantifiable business goals through output that captivates the customer and sets them apart from the competition.
            </p>
            <p className="text-gray-600 leading-relaxed">
              From competitive analysis to interactive prototypes, our agency implements engaging and simple-to-use user interfaces. Our user-friendly product design helps companies achieve quantifiable business goals through output that captivates the customer and sets them apart from the competition.
            </p>
          </div>
        </div>
      </section>

      {/* Additional Images */}
      <section className="bg-white py-8">
        <div className="container-main">
          <div className="grid md:grid-cols-2 gap-6">
            <div className="rounded-xl overflow-hidden aspect-[4/3]">
              <img
                src="https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&q=80"
                alt="Project screenshot 1"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="rounded-xl overflow-hidden aspect-[4/3]">
              <img
                src="https://images.unsplash.com/photo-1551650975-87deedd944c3?w=800&q=80"
                alt="Project screenshot 2"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Clients */}
      <section className="bg-gray-50 py-8">
        <div className="container-main">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-gray-500">Our Client</span>
            <div className="flex items-center gap-8 md:gap-16 overflow-x-auto">
              {clients.map((client) => (
                <span
                  key={client.id}
                  className="text-lg font-bold text-navy/40 whitespace-nowrap hover:text-navy transition-colors"
                >
                  {client.name}
                </span>
              ))}
            </div>
          </div>
        </div>
      </section>

      <FAQSection />
    </Layout>
  );
};

export default ProjectDetailPage;
